import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceShortText = ({ blok }) => (
  <div className="wrap">
    <div className="serviceshorttext-wrap inner-wrap" {...storyblokEditable(blok)}>
      <div className="serviceshorttext-content">
              <h2 className="text-2xl merriweather">{blok.subheadline}</h2>
      <p>{blok.infotext}</p>
      </div>

    </div>
  </div>
);

export default ServiceShortText;
